<template>
  <div class="element-input element-textbox" :class="{ disabled }">
    <div class="label">{{ label }}</div>
    <div class="body">
      <input type="text" v-model="model" :disabled="disabled" :placeholder="placeholder" />
    </div>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  props: [ "value", "label", "error", "disabled", "placeholder", "type" ],
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  methods: {
    selectItem( value ){
      this.$emit( "input", value );
    }
  }

}
</script>
